// Footer.tsx
import React from 'react';
import { Separator } from '@fluentui/react';

export const Footer: React.FC = () => {
  return (
    <>
      <Separator styles={{ root: { fontWeight: 'bold', margin: '20px 0' } }}>—</Separator>
      <div style={{ fontSize: '15px', color: '#666', lineHeight: '1.5' }}>
        ООО "Центр Экономики Строительства" <br />
        603057, г. Нижний Новгород, ул. Бекетова, д. 3 «б», оф. 260 <br />
        <a href="https://www.cesnnov.ru/ " target="_blank" rel="noopener noreferrer" style={{ color: '#0067B8' }}>
          www.cesnnov.ru
        </a>
      </div>
    </>
  );
};